import { MoreOutline } from '@doist/icons/product-ui';
import { Divider } from '@doist/marketist';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIIconButton } from '../product-ui-icon-button/product-ui-icon-button';
import { useProductUINSTranslation } from '../product-ui-ns-context';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { ProductUISidebar, ProfileMenu } from '../product-ui-sidebar/product-ui-sidebar';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUIView } from '../product-ui-view/product-ui-view';
import { ProductUIPreviewBanner } from '../product-ui-view-header/product-ui-preview-banner';
export function PreviewProjectsScene() {
  const {
    t
  } = useProductUINSTranslation();
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="PreviewProjectsScene" data-sentry-source-file="preview-projects.tsx">
            <ProductUISceneLayer position="bottomLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="preview-projects.tsx">
                <ProductUIAppWindow inlineSize={800} blockSize="calc(100% + 7px)" showSidebar={true} sidebar={<ProductUISidebar profileMenu={<ProfileMenu dailyProgress={0.7} />} views={<TemplateSidebarStandard />} />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIAppWindow.UIViews>
                                <ProductUIView variant="list">
                                    <ProductUIView.Header title={t('sequence.previewProjects.denisesSurpriseParty')} actions={<ProductUIIconButton icon={<MoreOutline />} />}>
                                        <ProductUIPreviewBanner ctaWrapper={children => <ProductUICursorContainer size="lg">
                                                    {children}
                                                </ProductUICursorContainer>}>
                                            {t('sequence.previewProjects.previewThisProject')}
                                        </ProductUIPreviewBanner>
                                    </ProductUIView.Header>
                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle skeletonWidth={20} />
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="60" />
                                        </ProductUITask>
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="80" />
                                        </ProductUITask>
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="40" />
                                        </ProductUITask>
                                        <Divider />
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle skeletonWidth={20} />
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="60" />
                                        </ProductUITask>
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="80" />
                                        </ProductUITask>
                                        <Divider />
                                        <ProductUITask>
                                            <ProductUISkeletonText width="40" />
                                        </ProductUITask>
                                    </ProductUIView.Section>
                                </ProductUIView>
                            </ProductUIAppWindow.UIViews>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="preview-projects.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}